<ngx-spinner type="ball-scale-multiple"></ngx-spinner>

<div class="page-container  gray-200">
  <div class="content-band width-full">
    <div class="inline-text-field-container flex-row gap-20 pb-20">
      <div class="pt-20 pb-20 basis-20">
        You belong to
        <b>{{ organizationsRoles?.userOrgs?.length }}</b> organization(s)
      </div>

      <div class="inline-text-field-container basis-50">
        <div class="select-container chevron border-bottom border-gray-600">
          @if (organizationsRoles?.userOrgs?.length === 1) {
            <label class="ds-floating-label-single">Select
            Organization</label>
          }
          <select class="ds-select-field rounded-4 hover-gray-300"
            [disabled]="organizationsRoles?.userOrgs?.length === 1" [(ngModel)]="selectedOrganization"
            (ngModelChange)="OnChangeorganizationDropdown($event)">
            @for (org of organizationsRoles?.userOrgs; track org) {
              <option [value]="org.orgKey">
                {{ org.orgName }} ({{ org.irn }})
              </option>
            }
          </select>
          @if (organizationsRoles?.userOrgs?.length !== 1) {
            <label class="ds-floating-label font-size-org-name">Select
            Organization</label>
          }
        </div>
      </div>
      <div class="basis-50"></div>
    </div>
    <div class="flex-row pb-20 pr-40">
      <div class="card fluid">
        <div class="card__content">
          @if (orgNameObj?.length > 0) {
            <div class="card__title">
              <b> {{ orgNameObj[0].orgName }} ({{ orgNameObj[0].irn }})</b>
              <hr class="mt-8" />
            </div>
          }
          <div class="card__title font-16">Role Name(s)</div>
          <div>
            <ul class="roles">
              @for (userRoles of userRoleObj?.userRoles; track userRoles) {
                <li>
                  {{ userRoles?.roleName }}
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-row pr-40">
      <div class="card fluid">
        <div class="card__content table">
          <table class="table system">
            <thead>
              <tr>
                <th>System Name</th>
                <th>System Description</th>
                <th>Application(s) Name</th>
                <th>Application Description</th>
              </tr>
            </thead>
            <tbody>
              @for (systemApp of systemResponse; track systemApp) {
                <tr>
                  <td>
                    <a class="pointer" (click)="navigateURl(systemApp)"
                      routerLinkActive="router-link-active">{{ systemApp?.system?.systemName }}
                    </a>
                  </td>
                  <td>{{ systemApp?.system?.systemDescript }}</td>
                  <td>
                    <ul>
                      @for (app of systemApp?.applications; track app) {
                        <li>
                          {{ app?.applicationName }}
                        </li>
                      }
                    </ul>
                  </td>
                  <td>{{ systemApp?.applications?.systemDescript }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>


</div>
